import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(5),
    },
    header: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(8),
    },
    divider: {
        maxWidth: theme.breakpoints.values.md,
    },
}));